// extracted by mini-css-extract-plugin
module.exports = {"AuthorSection":"AuthorArea-module--AuthorSection--2lvUB","AuthorImg":"AuthorArea-module--AuthorImg--26fqw","AuthorInfo":"AuthorArea-module--AuthorInfo--b_siF"};